// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BadgeFilter__container___39yc3{padding:128px 0 0}.BadgeFilter__inner___3eMjR{margin:0 auto;padding:0 24px}.BadgeFilter__title___1zsYZ{font-weight:200;font-size:48px;line-height:56px;text-align:center}@media (max-width:719px){.BadgeFilter__title___1zsYZ{font-size:32px;line-height:48px}}.BadgeFilter__description___16I_t{color:inherit;font-weight:400;font-size:16px;line-height:24px;margin-bottom:24px;color:#6b6651}.BadgeFilter__badges___15oam,.BadgeFilter__description___16I_t{text-align:center}@media (max-width:719px){.BadgeFilter__badges___15oam{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"container": "BadgeFilter__container___39yc3",
	"inner": "BadgeFilter__inner___3eMjR",
	"title": "BadgeFilter__title___1zsYZ",
	"description": "BadgeFilter__description___16I_t",
	"badges": "BadgeFilter__badges___15oam"
};
module.exports = ___CSS_LOADER_EXPORT___;
